import { HelpKitHelper } from '@ygtechnologies/bygr-frontend-tools';

export const helpkitHelper = new HelpKitHelper();


